module.exports = __webpack_public_path__ + "media/images/redesign-images/sorority-new/sorority-logos/s-logo-16-a8ed1cb48c39226d1b7babb60e0cb46c.svg";